import { type EntityState, createEntityAdapter } from '@reduxjs/toolkit'
import { apiSlice } from '../../../app/api/apiSlice'

import { type ExperienceType } from '../types/types'

const experienceTypeAdaptor = createEntityAdapter<ExperienceType>({
  selectId: (experienceType) => experienceType._id
})

type ExperienceTypeInitialState = EntityState<ExperienceType>

const initialState: ExperienceTypeInitialState =
  experienceTypeAdaptor.getInitialState()

export const extendedExperienceTypeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllExperienceTypes: builder.query<EntityState<ExperienceType>, void>({
      query: () => '/experience-type',
      transformResponse: (response: ExperienceType[]) => {
        return experienceTypeAdaptor.setAll(initialState, response)
      },
      providesTags: ["Experience"]
    }),
  }),
});

export const { useGetAllExperienceTypesQuery } = extendedExperienceTypeApiSlice
